/*
 * File: CustomPlatformSelection
 * Project: a-a
 * File Created: Friday, 21st November 2025 4:01:13 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 21st November 2025 4:03:01 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Typography } from '@mui/material';
import React from 'react';
import zeplinColor from '../../../theme/Color';

const CustomPlatformSelection = ({
  platformSelected,
  setAnchorEl,
  sf_token,
  setPlatformSelected,
}: {
  sf_token: string;
  platformSelected: string;
  setAnchorEl: React.Dispatch<React.SetStateAction<HTMLDivElement | null>>;
  setPlatformSelected: React.Dispatch<React.SetStateAction<string>>;
}) => {
  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <Typography variant='responsiveBody2'>Select Platform</Typography>
        <Box
          sx={{
            display: 'flex',
            gap: '8px',
          }}
        >
          <Box
            sx={{
              borderRadius: '10px',
              border: `1px solid ${
                platformSelected === 'Huddle' ? zeplinColor.BasicBlack : zeplinColor.Neutral5
              }`,
              padding: '12px',
              display: 'flex',
              gap: '8px',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
            onClick={() => setPlatformSelected('Huddle')}
          >
            <img
              src='/assets/huddle-icon.svg'
              style={{ width: '24px', height: '24px' }}
              alt='huddle'
            />
            <Typography variant='responsiveBody3'>Huddle</Typography>
          </Box>
          <Box
            sx={{
              borderRadius: '10px',
              border: `1px solid ${
                platformSelected === 'Salesforce' ? zeplinColor.BasicBlack : zeplinColor.Neutral5
              }`,
              padding: '12px',
              display: 'flex',
              gap: '8px',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
            onClick={(event) => {
              if (sf_token === 'true') {
                setPlatformSelected('Salesforce');
              } else {
                setAnchorEl(event.currentTarget);
              }
            }}
          >
            <img
              src='/assets/salesforce.svg'
              style={{ width: '24px', height: '24px' }}
              alt='huddle'
            />
            <Typography variant='responsiveBody3'>Salesforce</Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default CustomPlatformSelection;
